// src/components/GameTabs.jsx
import './GameTabs.css';
import { useNavigate } from "react-router-dom";
import React, { useContext } from 'react';
import { AppContext } from '../context/AppContext';
import axios from 'axios';
import { toast } from 'react-toastify';
import {
  getWithdrawalDisabledMessage,
  getWithdrawalWindowLabel,
  isWithdrawEnabled,
  parseWithdrawalTime,
} from '../utils/withdrawalSettings';

export default function GameTabs({ isAccountActive }) {
  const navigate = useNavigate();
    const { user, isInactive } = useContext(AppContext);
      if (isInactive || !isAccountActive) {
    return null; // Render nothing if the account is not active or inactive
  }

  const getFeeSettings = async () => {
    const token = localStorage.getItem("accessToken");
    const mobileNo = localStorage.getItem("mobileNo");

    const response = await axios.get("https://admin.gama567app.net/api/v1/fees-settings", {
      data: { mobileNo },
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        deviceId: "qwert",
        deviceName: "sm2233",
        accessStatus: "1",
      },
    });

    if (response.data.status && response.data.info) {
      localStorage.setItem("feeSettings", JSON.stringify(response.data.info));
      return response.data.info;
    }

    return null;
  };

  const handleWithdrawClick = async () => {
     if (!user?.accountStatus) {
      //alert("Your account is currently inactive. Please contact support.");
       // toast.error('Your account is currently inactive. Please contact support.');
      return; // Stop the function if the account is not active
    }

    try {
      const settings = await getFeeSettings();

      if (!settings) {
        toast.error("Could not load settings. Please refresh.");
        return;
      }

      const { withdrawOpenTime, withdrawCloseTime, withdrawStatus } = settings;

      if (!isWithdrawEnabled(withdrawStatus)) {
        toast.warn(getWithdrawalDisabledMessage(withdrawOpenTime, withdrawCloseTime));
        return;
      }

      const open = parseWithdrawalTime(withdrawOpenTime);
      const close = parseWithdrawalTime(withdrawCloseTime);

      if (!open || !close) {
        navigate("/funds/withdraw");
        return;
      }

      const now = new Date();
      const openTime = new Date();
      openTime.setHours(open.hours, open.minutes, 0, 0);

      const closeTime = new Date();
      closeTime.setHours(close.hours, close.minutes, 0, 0);

      if (now >= openTime && now <= closeTime) {
        navigate("/funds/withdraw");
      } else {
        toast.warn(`Withdrawal is only available from ${getWithdrawalWindowLabel(withdrawOpenTime, withdrawCloseTime)}.`);
      }
    } catch (error) {
      console.error("Error during withdrawal check:", error);
      toast.error("An unexpected error occurred.");
    }
  };
  
  const handleAddFundClick = () => {
     if (!user?.accountStatus) {
      //alert("Your account is currently inactive. Please contact support.");
      //  toast.error('Your account is currently inactive.Please contact support.');
      return; // Stop the function if the account is not active
    }
    navigate("/funds/add");
  };

  return (
    <div className="game-tabs-wrapper">
      <button className="game-tab bgchanges " onClick={handleAddFundClick} disabled={!user?.accountStatus}>
        {/* <span className="iccon-play" /> */}
        Add Fund
        <div className="playbts">
          <button className='btn_playebg bgrednone'>Add Now</button>
        </div>
      </button>

      <button className="game-tab bgchangeg2" onClick={handleWithdrawClick} disabled={!user?.accountStatus}>
        {/* <span className="iccon-play" /> */}
        Withdraw Fund
         <div className="playbts">
          <button className='btn_playebg bgred'>Withdraw</button>
        </div>
      </button>
    </div>
  );
}
